import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
  // common for component
  root: {
    marginLeft: '120px'
  },
  button: {
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit,
  },

  goalcourse: {
    height: '120px',
    width: '120px'
  },
  img: {
    height: '180px',
    width: '91px'
  },
  start: {
    height: '180px',
    width: '91px'
  },
  startText: {
    paddingTop: theme.spacing.unit * 1 + "1px",
  },
  leftCard: {
    padding: "13px 0px 14px 0px",
    marginTop: "-61px",
    marginLeft: "-157px",
    width:"358px",

  },
  rightCard: {
    padding: "10px 5px 10px 30px",
    marginTop: "-80px",
    marginLeft: "20px"
    //boxShadow: '10px 21px 41px rgba(0, 0, 0, 0.0519701)',
  },
  rightCards: {
    padding: "10px 5px 10px 30px",
    marginLeft: "20px",
    marginTop: "-80px"
  },
  headerText: {
    paddingLeft: theme.spacing.unit * 1 + "1px",
  },
  assignmentText: {
    paddingLeft: theme.spacing.unit * 0.2 + "1px",
    fontSize: "15px"
  },
  testHeader: {
    //paddingLeft: theme.spacing.unit * 0.5 + "1px",
  },
  testDate: {
    fontSize: "12px"
  },
  subHeaderText: {
    marginTop: "-70px",
    marginLeft: "0px"
  },
  mark: {
    width: '80px'
  },
  markImg: {
    marginTop: "-64px",
    marginLeft: "-169px"
  },
  markpanel: {
    height: '80px',
    width: '60px',
    marginLeft: "-90px"
  },
  markpanels: {
    position:"absolute",
    left:"164px",
    width: '55px',
    marginLeft: "-10px",
      marginTop:"-64px",
      paddingLeft:"0px"
  },
  goalText: {
    marginLeft: "150px",
    marginTop: "-70px",
  },
  circle_bg_pos_rel:{
    position:'relative',
    width: '250px',
    height:'250px',
    borderRadius: '100%',
    background:'#F6F6F6',
    textAlign:'center',
    padding:'30px 0 0 0',
  },
  textBarNega:{
    color: "#000",
    position: "absolute",
    fontSize: "24px",
    alignItems: "center",
    fontFamily:"Roboto",
    left: "26%",
    width: "110px",
    top: "34px",
    textAlign: "center",
    display: "inline-block"

  },
  textBarNega2:{
    color: "#666",
    position: "absolute",
    fontSize: "12px",
    alignItems: "center",
    left: "26%",
    top: "80px",
    display: "inline-block",
    textAlign: "center",
    width: "110px",
    fontFamily: "Roboto"
  },
  textBarNega3:{
    color: "#2196F3",   
    fontSize: "12px",
    alignItems: "center",   
    display: "inline-block",
    textAlign: "center",
    fontFamily: "Roboto",
    fontWeight:'bold',
  },
  textBarNega4: {   
    fontSize: "11px",
    color: "#999999",
    fontFamily: "Roboto",
    fontWeight:'normal',
    marginTop:'5px',
    display:'block',
  },
  mileStoneImg:
  {
    // height:"180px",
    // width:"110px"
  },
  goalIconImg:
  {
    width:"20px"
  },
  checkBox:{
    marginTop: "-31px",
    marginLeft: "323px",
  }

});
